import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default class SmoothScroll {
	constructor(element) {
		this.element = element;
		this.init();
	}

	init() {
		this.smoother = ScrollSmoother.create({
			smooth: 1.5,
			effects: true,
			wrapper: "#smooth-wrapper",
    		content: "#smooth-content",
		});
	}
}